import React, { HTMLAttributes, PropsWithChildren } from 'react'

import classNames from 'classnames'

import { getValidProps } from 'hsds/utils/react'

import { VisuallyHiddenUI } from './VisuallyHidden.styles'

type Props = {
  /** Custom class names to be added to the component. */
  className?: string
  /** Data attr for Cypress tests. */
  'data-cy'?: string
  /** Enables the ability to be tab focused. */
  focusable?: boolean
  /** Aria role to assign to the element */
  role?: string
} & HTMLAttributes<HTMLElement>

const VisuallyHidden = (props: PropsWithChildren<Props>) => {
  const { children, className, focusable, ...rest } = props
  const componentClassName = classNames(
    'c-VisuallyHidden',
    focusable && 'is-focusable',
    className
  )
  const tabIndex = focusable ? 1 : undefined

  return (
    <VisuallyHiddenUI
      {...getValidProps(rest)}
      className={componentClassName}
      tabIndex={tabIndex}
    >
      {children}
    </VisuallyHiddenUI>
  )
}

VisuallyHidden.defaultProps = {
  focusable: false,
  'data-cy': 'VisuallyHidden',
}

export default VisuallyHidden
